




















































import Vue from 'vue';
import { OutlinedTextInput, Toast } from '@/components/ds';
import { formatCpf, formatDateString, formatPhoneNumber } from '@/helpers/formatters';
import {
  isCpfValid,
  isDateStringValid,
  isEmailValid,
  isFinancialSponsorAgeValid,
  isMobilePhoneValid,
} from '@/helpers/validators';
import i18n from '@/i18n';

export interface PersonalDataFinancialSponsorFormEvent {
  cpf: string;
  email: string;
  phone: string;
  fullName: string;
  birthDate: string;
  hasErrors: boolean;
}

export default Vue.extend({
  components: { OutlinedTextInput, Toast },
  props: {
    currentCpf: {
      type: String,
      default: '',
    },
    currentEmail: {
      type: String,
      default: '',
    },
    currentPhone: {
      type: String,
      default: '',
    },
    currentFullName: {
      type: String,
      default: '',
    },
    currentBirthDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        cpf: this.currentCpf,
        email: this.currentEmail,
        phone: this.currentPhone,
        fullName: this.currentFullName,
        birthDate: this.currentBirthDate,
      },
      masks: {
        cpf: formatCpf,
        date: formatDateString,
        phone: formatPhoneNumber,
      },
      errors: {
        cpf: false,
        date: false,
        email: false,
        phone: false,
      },
      errorMessage: '',
      debounceTimeout: (null as unknown) as NodeJS.Timeout,
    };
  },
  methods: {
    inputHandler() {
      const { personalData } = this.$store.getters;

      this.errors.date =
        (!!this.form.birthDate && !isDateStringValid(this.form.birthDate)) ||
        !isFinancialSponsorAgeValid(this.form.birthDate);

      this.errors.email =
        !!this.form.email &&
        (!isEmailValid(this.form.email) || this.form.email === personalData?.email);

      this.errors.phone =
        !!this.form.phone &&
        (!isMobilePhoneValid(this.form.phone) ||
          this.form.phone === formatPhoneNumber(personalData?.phone));

      this.errors.cpf =
        !!this.form.cpf && (!isCpfValid(this.form.cpf) || this.form.cpf === personalData?.cpf);

      const hasErrors = Object.values(this.errors).some(Boolean);

      this.displayErrorMessages();

      this.$emit('input', { ...this.form }, hasErrors);
    },
    displayErrorMessages() {
      clearTimeout(this.debounceTimeout);
      Object.entries(this.errors).forEach(([key, value]) => {
        if (value) {
          this.debounceTimeout = setTimeout(() => {
            this.errorMessage = i18n.t(`personalData.financialSponsor.errors.${key}`);
          }, 1000);
        } else {
          this.errorMessage = '';
        }
      });
    },
  },
});
